export const MAX_CACHE_AGE = 60 * 60 // 1 hour
export const STALE_WHILE_REVALIDATE = 60 * 15 // 15 min
export const THEME_COLOR = '#f3f3f3'
export const MAX_WISHLIST_COUNT = 2
export const DEFAULT_SITE_TITLE = 'Brunello Cucinelli'